import React from 'react';
import { Skeleton, Tooltip } from 'antd';
import UserAvatar from 'shared/components/UserAvatar';
import { User } from 'types';
import './style.less';

interface AvatarStackProps {
  users: User[];
  size?: 'small' | 'large';
  overlap?: 'normal' | 'tight';
  loading?: boolean;
  tooltip?: boolean;
}

export const AvatarStack: React.FC<AvatarStackProps> = ({
  users,
  size = 'small',
  overlap = 'normal',
  loading,
  tooltip,
}) => {
  const maxMembers = size === 'small' ? 3 : 8;
  const avatarSize = size === 'small' ? 30 : 42;

  if (!users.length && !loading) {
    return null;
  }

  return (
    <div className={`AvatarStack AvatarStack--${size} AvatarStack--${overlap}`}>
      {loading ? (
        <>
          <Skeleton
            avatar={{ size: avatarSize }}
            title={false}
            paragraph={false}
            active
          />
          <Skeleton
            avatar={{ size: avatarSize }}
            title={false}
            paragraph={false}
            active
          />
          <Skeleton
            avatar={{ size: avatarSize }}
            title={false}
            paragraph={false}
            active
          />
        </>
      ) : (
        <>
          {users.slice(0, maxMembers).map(teamMember => (
            <Tooltip
              key={teamMember.id}
              title={tooltip ? teamMember.displayName : undefined}
            >
              <UserAvatar
                className="AvatarStack__avatar"
                user={teamMember}
                size={avatarSize}
              />
            </Tooltip>
          ))}
          {users.length - maxMembers > 0 && (
            <div className="AvatarStack__count">+{users.length - maxMembers}</div>
          )}
        </>
      )}
    </div>
  );
};
